import { StringObject } from "../../../objects/StringObject";
import {
  StringDevBadgeEntry,
  StringDevBadgeOverlayModule,
} from "../core/StringDevBadgeOverlayModule";
import { StringDevOverlayBadgeState } from "../core/StringDevOverlayModule";
import { INVIEW_TOGGLE_CSS } from "./StringInviewToggle.css";

interface InviewToggleExtra {
  onInviewChange: () => void;
}

const SVG_EYE_OPEN = `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M8 3C12.4183 3 16 5.23858 16 8C16 10.7614 12.4183 13 8 13C3.58172 13 0 10.7614 0 8C0 5.23858 3.58172 3 8 3ZM8 5C6.34315 5 5 6.34315 5 8C5 9.65685 6.34315 11 8 11C9.65685 11 11 9.65685 11 8C11 6.34315 9.65685 5 8 5Z" fill="currentColor"/></svg>`;

const SVG_EYE_OFF = `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M8 3C12.4183 3 16 5.23858 16 8C16 10.7614 12.4183 13 8 13C3.58172 13 0 10.7614 0 8C0 5.23858 3.58172 3 8 3ZM8 5C6.34315 5 5 6.34315 5 8C5 9.65685 6.34315 11 8 11C9.65685 11 11 9.65685 11 8C11 6.34315 9.65685 5 8 5Z" fill="currentColor"/><path fill-rule="evenodd" clip-rule="evenodd" d="M2 1L14 15Z" fill="#CCCCCC"/><path d="M2 1L14 15" stroke="currentColor"/></svg>`;

export class StringDevInviewToggle extends StringDevBadgeOverlayModule<InviewToggleExtra> {
  static override devtool = {
    id: "inview-toggle",
    label: "Inview",
    icon: "inview",
    order: 30,
    styles: INVIEW_TOGGLE_CSS,
    overlay: {
      layerName: "devtools-inview-toggle",
      zIndex: 10011,
      layerAttribute: "data-string-inview-toggle-layer",
      overlayId: "inview-toggle",
      badgeAttribute: "data-string-inview-toggle",
      defaultEnabled: true,
    },
  };

  canConnect(_object: StringObject): boolean {
    return true;
  }

  protected createBadgeExtra(object: StringObject): InviewToggleExtra {
    const onInviewChange = () => {
      const entry = this.entries.get(object.id);
      if (!entry) return;
      this.renderBadge(entry);
      this.needsMeasure = true;
      this.hasPendingMutate = true;
    };

    return { onInviewChange };
  }

  protected bindBadge(entry: StringDevBadgeEntry<InviewToggleExtra>): Array<() => void> {
    this.events.on(entry.object.getScopedEventName("object:inview"), entry.extra.onInviewChange);
    return [
      () => this.events.off(entry.object.getScopedEventName("object:inview"), entry.extra.onInviewChange),
    ];
  }

  protected onBadgeClick(entry: StringDevBadgeEntry<InviewToggleExtra>, _event: MouseEvent): void {
    const object = entry.object;
    if (object.htmlElement.classList.contains("-inview")) {
      object.setInviewAutoBlocked(true);
      object.htmlElement.classList.remove("-inview");
    } else {
      object.setInviewAutoBlocked(false);
      object.syncInviewClass();
    }

    this.renderBadge(entry);
  }

  protected getBadgeState(
    entry: StringDevBadgeEntry<InviewToggleExtra>,
  ): StringDevOverlayBadgeState {
    const object = entry.object;
    const isInView = object.getProperty<boolean>("is-inview") === true;
    const isBlocked = object.isInviewAutoBlocked();
    const shouldRepeat = object.getProperty<boolean>("repeat") === true;
    const hasClass = object.htmlElement.classList.contains("-inview");
    const isActive = isBlocked ? false : isInView ? true : shouldRepeat ? false : hasClass;

    return {
      active: isActive,
      title: isBlocked ? "Enable automatic -inview" : "Disable automatic -inview",
      html: isActive ? SVG_EYE_OPEN : SVG_EYE_OFF,
      attributes: {
        "data-inview": isInView,
        "data-blocked": isBlocked,
      },
    };
  }

}

export { StringDevInviewToggle as StringInviewToggle };
